module.exports = __webpack_public_path__ + "img/arrow-select.71fd338d.svg";